module.exports = {
  commonBase: {
    wz0: "operation type",
    wz1: "operation",
    wz2: "maint",
    wz3: "self operation",
    wz4: "franchised",
    wz5: "jiont operation",
    wz6: "Managed",
    wz7: "shared private points",
    wz8: "private charge",
    wz9: "Non private charge",
    wz10: "todos",
  },
  PowerBoxDetail: {
    title1: "general infomation",
    title2: "reference no. of meter reading module",
    title3: "equipment name",
    title4: "Hardware properties",
    title5: "current firmware model",
    title6: "current version",
    title7: "meter data",
    value1: "phase A current",
    value2: "phase A voltage",
    value3: "phase B current",
    value4: "phase B voltage",
    value5: "phase C current",
    value6: "phase C voltage",
    value7: "phase A electric energy",
    value8: "phase B electric energy",
    value9: "phase C electric energy",
    value10: "phase A power",
    value11: "phase B power",
    value12: "phase C power",
    value13: "Three-phase electric energy (kWh)",
    value14: "Total electric energy - peak value (kWh)",
    value15: "Total electric energy - sharp value (kWh)",
    value16: "Total electric energy - off-peak value (kWh)",
    value17: "Total electric energy - shoulder value (kWh)",
    value18: "Three-phase power",
    wz1: "Firmware Info.",
  },
  powerBoxList: {
    title1: "reference NO. of meter reading module",
    placeholder1: "enter the reference number",
    placeholder2: "please enter charging station",
    title2: "Charging Station",
    btn1: "search",
    title3: "cabinet reference number",
    title4: "Charging Station",
    title5: "current firmware model",
    title6: "current version",
    title7: "reference NO. of voltmeter",
    title8: "rated power",
    action: "operation",
    title9: "Detail",
    title10: "Equipment",
    title11: "Equipment",
    title12: "Detail",
    wz1: "firmware info.",
    wz2: "reference no. of voltmeter",
  },
  configModify: {
    title1: "configuration field (field scope)",
    title2: "device configuration",
    title3: "platform configuration",
    title4: "order details",
  },
  logDetail: {
    title1: "parameter field",
    title2: "before change",
    title3: "after change",
  },
  modifyLog: {
    actionSheet: "operation type",
    btn1: "modification",
    btn2: "synchronized arrangement",
    title1: "operation mode",
    title2: "online modification",
    title3: "offline modification",
    title4: "service platform",
    title5: "operator",
    title6: "operating time",
    btn3: "change of parameter",
    btn4: "view",
  },
  orderChargeCourse: {
    title1: "info of charge point",
    title2: "info of module",
  },
  orderDetailInfo: {
    title1: "no. of business order",
    title2: "no. of platform order",
    title3: "car model",
    title4: "license plate number",
    title5: "VIN code",
    title6: "charging time (recorded by platform )",
    title7: "charging time (recorded by terminal )",
    title8: "equipment reference",
    title9: "charging duration",
    title10: "name of the charging station",
    title11: "charging capacity (kWh)",
    title12: "charging status",
    state1: "loading",
    state2: "in the charging process",
    state3: "charging complete",
    title13: "passcode",
    title14: "stop reason",
  },
  powerMoudleChargeCourse: {
    brand1: "Delta",
    brand2: "Star Charge",
    brand3: "ZTE",
    title1: "fault message",
    msg1: "voltage",
    msg2: "current",
    msg3: "temperature",
    wz1: "no. of order",
    wz3: "no data",
  },
  stubChargeCourse: {
    title1: "output voltage of charger",
    title2: "car battery voltage",
    title3: "output current of charger",
    title4: "car battery current",
    title5: "Total electric energy",
    title6: "battery temperature",
    title7: "connector temperature",
    title8: "temperature of charging point",
    title9: "voltage",
    title10: "current",
    title11: "SOC",
    title12: "state of charge",
    title13: "Total electric energy",
  },
  stubDetailInfo: {
    title1: "General Infomation",
    title2: "equipment reference",
    title3: "surbordinate charging station",
    title4: "equipment name",
    title5: "type",
    title6: "AC",
    title7: "DC",
    title8: "AC/DC",
    title9: "model",
    title10: "status",
    title11: "status logs",
    title12: "with connector or not",
    title13: "voltage upper limit(V)",
    title14: "voltage lower limit(V)",
    title15: "real-time power(kW·h)",
    title16: "Max. power(kW·h)",
    title17: "auxiliary voltage(V)",
    title18: "Software Info.",
    title19: "firmware version",
    title20: "firmware model",
    title21: "hardware info.",
    title22: "Number of Iccid",
    title23: "status logs",
    no: "No",
    yes: "Yes",
    wz1: "firmware info.",
  },
  stubList: {
    placeholder1: "enter the reference number",
    title1: "Equipment Reference Number",
    placeholder2: "please enter the name",
    title2: "Charging Station",
    placeholder3: "enter the reference no. of voltmeter",
    placeholder4: "",
    title3: "reference no. of voltmeter",
    title4: "All",
    title5: "AC",
    title6: "DC",
    title7: "AC/DC",
    title8: "please choose",
    title9: "Equipment Type",
    title10: "please choose",
    title11: "Equipment Model",
    title12: "please choose",
    title13: "Version",
    title14: "please choose",
    title15: "Model",
    title16: "search",
    title17: "Reference Number",
    title18: "Charging Station",
    title19: "Equipment Type",
    title20: "AC",
    title21: "DC",
    title22: "AC/DC",
    title23: "unkown",
    title24: "Equipment Model",
    title25: "firmware version",
    title26: "firmware model",
    title27: "Equipment Status",
    action: "Setting",
    btn1: "equipment details",
    btn2: "revise status",
    btn3: "equipment details",
    btn4: "info.",
    btn5: "order details",
    btn6: "revise status",
    btn7: "configuration",
    btn8: "export",
    title28: "equipment reference",
    title29: "search",
    title30: "",
    dw: "day (s)",
    hour: "hour",
    minute: "mins",
    second: "second",
    btn: "equipment list",
    wz1: "enter the reference number",
    wz2: "Cabinet Reference Number",
    wz3: "Firmware Info.",
    wz4: "equipment reference",
    wz5: "configuration",
    wz6: "module info.",
    wz7: "to obtain firmware info.",
    wz8: "firmware update",
    wz9: "region",
  },
  stubOrderInfo: {
    placeholder1: "please choose the date (range)",
    title1: "end time of order",
    btn1: "search",
    btn2: "export",
    title2: "platform order NO. ",
    title3: "time",
    title4: "energy consumption(kWh)",
    title5: "status",
    title6: "loading",
    title7: "in the charging process",
    title8: "charging complete",
    title9: "stop reason",
    action: "operation",
    btn3: "Details",
    btn4: "Process",
    btn5: "Process",
    btn6: "Details",
    wz1: "no. of business order", // 一下机翻
    wz2: "no. of business order",
    wz3: "no. of platform order",
    wz4: "no. of platform order",
    wz5: "equipment reference",
    wz6: "equipment reference",
    wz7: "user ID",
    wz8: "user ID",
    wz9: "charging channels",
    wz10: "charging channels",
    wz11: "end time of order",
    wz12: "stop reason",
    wz13: "stop reason",
    wz14: "charging station",
    wz15: "region",
    wz16: "charging time (recorded by terminal )",
    wz17: "charging duration",
    wz18: "Equipment data", // 以下机翻译
    wz19: "Module data",
    wz20: "Platform log",
    wz21: "Platform log",
  },
  stubParamsConfig: {
    title1: "configuration field (field scope)",
    title2: "equipment configuration",
    title3: "platform configuration",
    btn3: "download",
    title4: "modification timescale of platform configuration",
    title5: "configuration field (field scope)",
    title6: "equipment configuration",
    title7: "platform configuration",
    msg1:
      "There may be a delay in obtaining information. You can click 'Get Device Configuration' to check the latest information.",
    msg2: "successful",
    msg3: "no modification, please select the CANCEL button to close the window",
    msg4: "command issued successfully",
    title8: "equipment reference",
    title9: "name of charging station",
    title10: "Configure the verification code on the device",
    title11: "Time change configuration on the device",
    title12: "Configure the reporting time on the device",
    title13: "Configure the verification code on the platform",
    title14: "Configure the delivery time on the platform",
    title15: "Last modified time on the platform",
    title16: "configuration template",
    title17: "to obtain configuration data of terminal",
    title18: "modify configuration data of platform",
    title19: "Configure on the platform",
    title20: "Configure on the device side",
    title21: "Batch platform configuration",
    title22: "Batch device configuration",
    btn1: "cancel",
    btn2: "Save",
    wz1: "configuration",
  },
  stubStatusLog: {
    title1: "please choose the month",
    btn1: "search",
    btn2: "export",
    title2: "Report time",
    title3: "status code",
    title4: "status information",
    title5: "user account",
  },
  stubStatusUpdate: {
    msg1: "Successful operation",
    msg2_1: "Content length should be between",
    msg2_2: "and",
    msg2_3: "",
    title1: "status modification",
    placeholder1: "please choose a status to modify",
    placeholder2: "please choose",
    state1: "system maintaining",
    state2: "offline",
    title2: "modification reason",
    placeholder3: "please enter the modification reason",
    btn1: "confirm",
  },
  stubGroupList: {
    placeholder1: "please choose a region",
    title1: "Region",
    title2: "Charging Station",
    btn1: "search",
    title3: "DC",
    title4: "AC",
    title5: "Region",
    action: "Setting",
    btn2: "equipment",
    btn3: "Equipment",
    btn4: "distribution",
    btn5: "Cabinets Distribution",
    all: "All",
  },
  appkeySuccessRate: {
    title1: "rank list",
    title2: "channel",
    title3: "orders in total",
    title4: "Number of failed orders",
    title5: "success rate",
    tool1: "success rate = no. of completed orders / orders in total",
    btn1: "order list",
    wz1: "order details",
  },
  chargeOrderDetail: {
    btn1: "export",
    title1: "order reference",
    title2: "equipment reference",
    title3: "charging duration (recorded by platform )",
    title4: "user ID",
    title5: "Total electric energy",
    title6: "VIN code",
    title7: "model",
    title8: "charging channels",
    title9: "stop reason",
    action: "operation",
    btn2: "charging process",
  },
  chargSuccess: {
    placeholder1: "please choose the date (range)",
    title1: "date",
    placeholder2: "please choose a region",
    title2: "region",
    operationMode1: "All",
    operationMode2: "Managed",
    operationMode3: "jiont operation",
    operationMode4: "self operation",
    operationMode5: "franchised",
    operationMode6: "interactivity",
    operationMode7: "shared private points",
    placeholder3: "please choose",
    title3: "operation type",
    all: "All",
    type1: "AC",
    type2: "DC",
    placeholder4: "please choose",
    title4: "equipment type",
    btn1: "search",
    title5: "Charging success rate of regional AC and DC charging points",
    title6: "Charging success rate of different firmware versions",
    title7: "Reasons for connector shut-off",
    title8: "TOP50 channel charging success rate",
  },
  citySuccessRate: {
    title1: "rank",
    title2: "region",
    title3: "number of order",
    title4: "in total",
    msg1: "AC",
    msg2: "DC",
    msg3: "in total",
    title5: "Number of successful orders",
    title6: "Number of failed orders",
    title7: "success rate",
    tool1: "Success rate = successful charging order/total charging order",
    title8: "in total",
    title9: "Number of successful orders",
    title10: "Number of failed orders",
    title11: "Charging success rate",
    title12: "number of order",
    title13: "success rate",
    title14: "Number of successful orders",
    title15: "Number of failed orders",
    title16: "Charging success rate",
    btn1: "figure",
    btn2: "table",
    wz1: "order details",
  },
  endCodeSuccessRate: {
    title1: "stop reason",
    title2: "Abnormally failed order",
    title3: "proportion",
    title4: "order list",
    wz1: "order details",
  },
  versionTypeSuccessRate: {
    title1: "version",
    title2: "number of order",
    msg1: "AC",
    msg2: "DC",
    msg3: "in total",
    title3: "Number of successful orders",
    title4: "Number of failed orders",
    title5: "success rate",
    tool1: "Success rate = successful charging order/total charging order",
    all: "in total",
    type1: "GBT 2011 1.0",
    type2: "GBT 2015 2.0",
    type3: "GBT 2015 2.1",
    type4: "Beginning of test \n version 9",
    msg4: "unkown",
    title6: "Number of successful orders",
    title7: "Number of failed orders",
    title8: "Charging success rate",
    title9: "number of order",
    title10: "success rate",
    title11: "Number of successful orders",
    title12: "Number of failed orders",
    title13: "Charging success rate",
    btn1: "figure",
    btn2: "table",
    wz1: "order details",
  },
  stubDate: {
    title1: "date",
    title2: "Average operating duration",
    tool1:
      "Operation duration: idle duration (including the idle time of the connector insertion) + charging duration + parking space occupation time + fault duration + offline duration + upgrade duration + appointment waiting duration + energy storage duration + online reservation duration + full charged duration;",
    tool1_2: "Average operating time: The average operating time of all statistical equipment.",
    title3: "Fautly equipment",
    title4: "Average fault duration",
    tool2:
      "Fault duration: The period from when the device changes to a fault state until the device changes to another state.",
    tool2_2: "Average duration of fault: The average duration of all faulty devices.",
    title5: "fault rate",
    tool3: "Fault rate = fault duration/operation duration",
    title6: "off-line equipment",
    title7: "average offline duration",
    tool4:
      "Offline duration: The time period from when the device changes to the offline state until the device changes to another state.",
    tool4_2: "Average duration of offline: The average duration of failure of all offline devices.",
    title8: "offline rate",
    tool5: "Offline rate = offline duration/operation duration",
    title9: "average intact duration",
    tool6: "Intact duration = operating duration-fault duration-offline duration",
    tool6_2: "Average intact duration: the average intact duration of all statistical equipment",
    tool7: "Intact rate = (operating duration-offline duration-fault duration) / operating duration",
    dw: "day (s)",
    hour: "hour",
    minute: "mins",
    second: "second",
    totle: "in total",
    title10: "intact rate",
    title11: "offline rate",
    title12: "fault rate",
    data: "date",
    btn: "equipment list",
  },
  stubDetail: {
    state1: "fault",
    state2: "offline",
    btn1: "quick query of equipment",
    btn2: "export",
    title1: "equipment reference",
    title2: "surbordinate charging station",
    title3: "equipment type",
    type1: "AC",
    type2: "DC",
    type3: "AC/DC",
    type4: "unkown",
    title4: "operation type",
    operationMode1: "Managed",
    operationMode2: "jiont operation",
    operationMode3: "self operation",
    operationMode4: "franchised",
    operationMode5: "interactivity",
    operationMode6: "shared private points",
    operationMode7: "unkown",
    title5: "equipment model",
    title6: "firmware model",
    title7: "firmware version",
    title8: "duration",
    title9: "times",
    title10: "last time",
    title11: "time",
    title12: "region",
    dw: "day (s)",
    hour: "hour",
    minute: "mins",
    second: "second",
  },
  stubIntact: {
    placeholder1: "please choose the date (range)",
    title1: "date",
    placeholder2: "please choose a region",
    title2: "region",
    no: "No",
    yes: "Yes",
    msg1: "show subordinates",
    operationMode1: "All",
    operationMode2: "Managed",
    operationMode3: "jiont operation",
    operationMode4: "self operation",
    operationMode5: "franchised",
    operationMode6: "interactivity",
    operationMode7: "shared private points",
    placeholder3: "please choose",
    title3: "operation type",
    type0: "All",
    type1: "AC",
    type2: "DC",
    placeholder4: "please choose",
    title4: "equipment type",
    areaFirst: "region first",
    operationFirst: "operation type first",
    placeholder5: "please choose",
    title5: "sort",
    btn1: "search",
    title6: "present by date",
    title7: "present by category",
    wz1: "Region segmentation", // 自翻
  },
  stubType: {
    title1: "equipment type",
    title2: "Average operating duration",
    tool1:
      "Operation time: idle time (including the idle time of the connector insertion) + charging duration + parking space occupation time + fault duration + offline duration + upgrade duration + appointment waiting duration + energy storage duration + online reservation duration + full charged duration;",
    tool1_2: "Average operating time: The average operating time of all statistical equipment.",
    title3: "Fautly equipment",
    tool2:
      "Fault duration: The period from when the device changes to a fault state until the device changes to another state.",
    tool2_2: "Average fault duration: The average duration of all faulty devices.",
    title4: "average fault duration",
    title5: "fault rate",
    tool3: "Fault rate = fault duration/operation duration",
    title6: "off-line equipment",
    title7: "in total",
    tool4:
      "Offline duration: The time period from when the device changes to the offline state until the device changes to another state.",
    tool4_2: "Average duration of offline: The average duration of failure of all offline devices.",
    title8: "average offline duration",
    tool5: "Offline rate = offline duration/operation duration",
    title9: "offline rate",
    tool6: "Intact duration = operating duration-fault duration-offline duration",
    tool6_2: "Average intact duration: the average intact duration of all statistical equipment",
    title10: "average intact duration",
    title11: "intact rate",
    tool7: "Intact rate = (operating duration-offline duration-fault duration) / operating duration",
    title12: "equipment list",
    title13: "region",
    title14: "operation type",
    dw: "day (s)",
    hour: "hour",
    minute: "mins",
    second: "second",
  },
  equipmentIntact: {
    placeholder1: "please choose the date",
    title1: "date",
    placeholder2: "please choose the date",
    btn1: "search",
    btn2: "data export",
    title2: "operation type",
    operationMode1: "Managed",
    operationMode2: "jiont operation",
    operationMode3: "self operation",
    operationMode4: "franchised",
    operationMode5: "interactivity",
    operationMode6: "shared private points",
    operationMode7: "unkown",
    title3: "total number of charging points",
    type1: "AC",
    type2: "DC",
    totle: "in total",
    title4: "charging points under construction",
    title5: "existing charging points",
    title6: "charging points in maintenance",
    title7: "avaible charging points",
    title8: "avaible rate",
    title9: "charging points in full operation",
    title10: "intact rate",
    title11: "Subsidised points with no operating value",
    title12: "Intact rate (excluding subsidised points)",
    title13: "Operation type analysis",
  },
  crcExceptionList: {
    placeholder1: "please enter the equipment reference",
    title1: "equipment reference",
    placeholder: "please choose",
    title2: "equipment model",
    title3: "firmware inquiry",
    type0: "All",
    type1: "AC",
    type2: "DC",
    type3: "AC/DC",
    title4: "equipment type",
    btn1: "search",
    btn2: "Batch platform configuration",
    btn3: "Batch device configuration",
    title5: "equipment reference",
    title6: "CRC of platform",
    title7: "CRC of equipment",
    title8: "equipment type",
    title9: "AC",
    title10: "DC",
    title11: "AC/DC",
    result1: "unkown",
    title12: "equipment model",
    title13: "firmware info.",
    action: "operation",
    btn4: "view configuration",
    btn5: "Configure on the platform",
    btn6: "Configure on the device side",
    msg1: "successful",
    msg2: "Please at least choose one item",
    msg3: "Up to 100 simultaneous processing",
    msg5: "equipment configuration",
  },
  addEquipment: {
    msg1: "Please at least choose one charging station",
    msg2: "The selected power station already exists",
    msg3: "added successfully",
    msg4: "Please at least choose one charging station",
    msg5: "The selected charging station is not added or has been deleted",
    msg6: "delete succesfully",
    msg7: "Please at least choose one charging station",
    msg8: "successful application",
    msg9: "add a connector",
    bnt1: "Delete the charging station",
    msg10: "Up to 100 power stations can be displayed on the screen.",
  },
  cfgChangeTaskBuild: {
    btn1: "Configuration upload",
    msg1: "Configuration content cannot be empty",
    msg2: "successful",
    msg3: "successful upload",
    btn2: "upload again",
    title1: "task description",
    title2: "Uploaded configuration file",
    title3: "Configuration content",
    title4: "verification result",
    title5: "verification is correct",
    title6: "Abnormal onfiguration item",
    btn5: "Configuration download",
    btn3: "Confirm",
    btn4: "cancel",
    title7: "remarks",
  },
  cfgExport: {
    placeholder1: "please select the connector reference and configuration item(s)",
    title1: "task range",
    title2: "configuration options",
    placeholder: "please choose",
    btn1: "Configuration export",
    btn2: "cancel",
    btn3: "add",
  },
  equipmentListModal: {
    btn1: "Current station",
    btn2: "add in bulk",
    placeholder1: "please choose a region",
    title1: "region",
    title2: "name of charging station",
    btn3: "search",
    title3: "connector reference",
    title4: "region",
    title5: "name of charging station",
    btn5: "operation",
    btn4: "add",
    msg1: "Cannot query by province",
    title6: "Charging station inquiry",
    btn6: "cover",
  },
  equipmentListModalDel: {
    title1: "region",
    placeholder1: "please choose a region",
    placeholder: "please choose",
    all: "All",
    type1: "self-operating",
    type2: "non-self-operating",
    title2: "operation type",
    title3: "name of charging station",
    btn1: "search",
    btn2: "delete",
    btn3: "Charging station inquiry",
    action: "operation",
  },
  stationListModal: {
    select: "Select all/not select",
    btn1: "choose the current item",
    btn2: "add in bulk",
    title1: "region",
    placeholder1: "please choose a region",
    title2: "name of charging station",
    btn3: "search",
    title8: "region",
    placeholder2: "please choose a region",
    title3: "name of charging station",
    btn4: "search",
    title4: "connector reference",
    title5: "region",
    title6: "name of charging station",
    btn5: "operation",
    btn6: "add",
    title7: "Charging station inquiry",
  },
  taskExecuteResult: {
    title1: "equipment reference",
    msg1: "successful",
    msg2: "Failed to modify platform configuration",
    msg3: "Configuration delivery failed",
  },
  taskManagement: {
    placeholder1: "please enter the operator",
    title1: "founder",
    all: "All",
    btn1: "Configuration modification",
    btn2: "firmware update",
    placeholder: "please choose",
    title11: "task type",
    state1: "unexecuted",
    state2: "executed",
    title2: "task status",
    placeholder2: "please choose the date (range)",
    title3: "creation time",
    btn3: "search",
    btn4: "create a new task",
    btn5: "Configuration export",
    actionSheet: "operation description",
    title4: "founder",
    title5: "creation time",
    title6: "task type",
    btn6: "Configuration modification",
    btn7: "firmware update",
    title7: "Number of operating points",
    title8: "task status",
    state3: "unexecuted",
    title10: "result of execution",
    title9: "remarks",
    action: "operation",
    btn8: "task execution",
    msg1: "successful",
    btn9: "view tasks",
    btn10: "delete",
    msg2: "successful",
    btn11: "choose a task",
    btn12: "Configuration export",
    btn13: "view tasks",
    btn14: "result details",
  },
  taskSelect: {
    placeholder1: "Please select a task type",
    btn1: "Configuration modification",
    btn2: "create a task",
    modaltitle1: "create a new task",
  },
  account: {
    msg1: "no data",
    btn1: "add user",
    btn2: "allocate",
    title1: "user management",
    title2: "user list",
    title3: "user name",
    title4: "user contact number",
    title5: "user email address",
    action: "operation",
    btn3: "allocate",
    placeholder1: "please enter the user name",
    title6: "user name",
    btn4: "search",
    btn5: "add user",
    wz1: "account",
  },
  addAccountModal: {
    placeholder1: "please check the user name first",
    title1: "user name",
    btn1: "search",
    title2: "contact number",
    title3: "mailbox",
    action: "operation",
    btn2: "add",
    msg1: "added successfully",
  },
  dispatchRoleModal: {
    title1: "all roles",
    title2: "selected roles",
    placeholder1: "please enter search content",
    msg1: "no options",
    dw1: "item",
    btn1: "Confirm",
    btn2: "Clear",
  },
  dispatchPermissionsModal: {
    title1: "Authority Name",
    placeholder1: "please enter the name",
    title2: "Unselected Authority",
    title3: "Selected Authority",
    placeholder2: "please search",
    msg1: "no options",
    dw1: "unit",
    btn1: "Confirm",
    btn2: "Clear",
    title4: "name of the authority",
    placeholder3: "please enter the name of the authority",
    placeholder4: "please search",
  },
  permissionList: {
    title1: "Authority Settings",
    title2: "Menu read authority",
    title3: "Menu assigned authority",
    title4: "Menu region query authority",
    title5: "Authority Name",
    placeholder1: "please enter the name ",
    btn1: "search",
    btn2: "add",
    title6: "Authority Name",
    action: "Setting",
    btn3: "edit",
    btn4: "delete",
  },
  editRoleModal: {
    title1: "role name",
    placeholder1: "please enter the role name",
    choose1: "all authority",
    choose2: "Selected authority",
    placeholder2: "please enter search content",
    msg1: "no options",
    dw1: "item",
    btn1: "Confirm",
    title2: "role name",
    placeholder3: "please enter the role name",
  },
  role: {
    title1: "role settings",
    title2: "role name",
    action: "operation",
    btn1: "edit roles",
    btn2: "delete",
    btn3: "add",
  },
  roleList: {
    title1: "role settings",
    title2: "role name",
    placeholder1: "please enter the role name",
    btn1: "search",
    btn2: "add",
    title3: "role name",
    title4: "status",
    state1: "normal",
    state2: "disabled",
    action: "operation",
    btn3: "edit roles",
    btn4: "delete",
  },
  no_access: {
    msg1: "No access",
    msg2: "Automatically return to the login page after ",
    btn1: "Back to top",
  },
  no_connect: {
    msg3: "Server or interface failure",
  },
  no_menu: {
    msg1:
      "You have no menu authority, or the account login has timed out, please contact the administrator to add authority",
    msg2: "skip to login page",
    wz1: "skip to next page",
  },
  nofound: {
    msg1: "The page you visited does not exist, please try again!",
  },
  formCore: {
    msg1: "no options",
    msg2: "Interface request failed",
    msg3: "Form is a horizontal layout, a shuttle box is not allowed.",
    msg4: "Content length should be between",
    msg4_2: "and",
    msg4_3: "",
    msg5: "value must be ≥",
    msg5_2: "or ≤",
    msg5_3: "",
    msg6: "Number of decimal places must be ≤",
    msg7: "Please enter the correct value",
    msg8: "Please enter a positive number",
    msg9: "The value must be a positive integer ≥",
    msg9_2: "or a positive integer ≤",
    msg9_3: "",
    msg10: "Please enter a positive integer",
    msg11: "Please enter a non-zero positive integer",
    msg12: "incorrect contact number",
    msg13: "Please tick",
    msg14: "verification",
    msg15: "No query across years",
    msg16: "up to",
    msg19: "days",
    msg17: "at least",
    msg18: "date verification",
    placeholder1: "Please enter something",
    all: "All",
  },
  gridTableCore: {
    msg1: "total ",
    msg1_2: "",
    msg2: "N/A",
    msg3: "picture preview",
    msg4: "Are you sure of ",
    msg4_2: "",
    btn1: "Confirm",
    btn2: "cancel",
    btn3: "More",
    msg5: "fail to build a table",
    msg6: "building a batle",
    wz1: "no data",
  },
  scLayoutTab: {
    msg1: "Please close unnecessary windows!",
    btn1: "Log out",
    web1: "Google",
    web2: "",
    webc: "recommended browser",
    msg2: "Version number",
    company: "Wanbang Charging Equipment Co. Ltd.",
    title1: "Change Password",
    lan1: "Chinese",
    lan2: "English",
    lan3: "Spain",
    wz1: "Change password",
  },
  fetchHandler: {
    msg1: "no such category",
    msg2: "No placeholder charging rule found for station group",
  },
  moduleList: {
    state1: "All",
    state2: "normal",
    state3: "fault",
    placeholder1: "please enter the number of module",
    placeholder2: "please enter the equipment reference",
    title1: "equipment reference",
    placeholder3: "please choose",
    title2: "module reference",
    title3: "equipment reference",
    title4: "brand",
    title5: "module type",
    value1: "kw High voltage electricity",
    value2: "kw Low voltage electricity",
    action: "operation",
    modalTitle1: "history equipment",
    brand1: "Delta",
    brand2: "Star Charge",
    brand3: "ZTE",
    btn1: "search",
    dw: "day (s)",
    hour: "hour",
    minute: "mins",
    second: "second",
    wz1: "fault message",
    wz2: "running duration",
    wz3: "The fault log", // 机器
  },
  moduleInfo: {
    placeholder1: "please choose the date (range)",
    title1: "duration of date",
    btn1: "search",
  },
  historyStubInfo: {
    placeholder1: "please enter the equipment reference",
    title1: "equipment reference",
    title2: "running duration",
    btn1: "search",
    dw: "day (s)",
    hour: "hour",
    minute: "mins",
    second: "second",
    wz1: "in total",
    wz2: "info. of module",
  },
  eventMonitoring: {
    placeholder1: "please enter the event name",
    placeholder2: "please enter the main reference",
    title1: "main reference",
    placeholder3: "please choose the region",
    title2: "region",
    placeholder4: "please choose",
    title3: "operation level",
    operationMode1: "All",
    operationMode2: "Managed",
    operationMode3: "jiont operation",
    operationMode4: "self operation",
    operationMode5: "franchised",
    operationMode6: "interactivity",
    operationMode7: "shared private points",
    placeholder: "please choose",
    title4: "operation type",
    placeholder5: "please choose the duration of date",
    title5: "date",
    title6: "search",
    title7: "event name",
    title8: "event type",
    title9: "main reference",
    title10: "equipment reference",
    title11: "operation level",
    title12: "times",
    title13: "reporting time",
    title14: "name of the charging station",
    title15: "region",
    title16: "operation type",
    title17: "equipment model",
    title18: "details",
    action: "operation",
    btn1: "module data",
    wz1: "power module",
    wz2: "info of module",
    all: "All",
  },
  faultReportingList: {
    placeholder1: "please enter the fault name",
    title1: "fault name",
    placeholder2: "please enter the equipment reference",
    title2: "equipment reference",
    placeholder3: "please choose the region",
    title3: "region",
    placeholder: "please choose",
    title4: "operation level",
    title5: "operation type",
    placeholder4: "please choose the duration of date",
    title6: "date",
    btn1: "search",
    title7: "equipment reference",
    title8: "fault code",
    title9: "fault name",
    title10: "operation level",
    title11: "times",
    title12: "lastest reporting time",
    title13: "name of the charging station",
    title14: "region",
    title15: "operation type",
    title16: "model",
    title17: "version-model",
    operationMode1: "All",
    operationMode2: "Managed",
    operationMode3: "jiont operation",
    operationMode4: "self operation",
    operationMode5: "franchised",
    operationMode6: "interactivity",
    operationMode7: "shared private points",
    all: "All",
  },
  exportBtn: {
    msg1: "no data",
    placeholder1: "please choose the search parameters",
    btn1: "export",
  },
  publicParam: {
    all: "All",
    type1: "Starcharge-App",
    type2: "Starcharge-SAAS",
    type3: "SAAS-account",
    type4: "星星充电-微信",
    btn1: "choose",
    btn2: "Confirm",
    btn3: "reset",
    msg1: "no data",
  },
  TreeTransfer: {
    wz1: "unit",
    wz2: "please enter search keywords",
    wz3: "source data",
    wz4: "destination data",
  },
  login3: {
    lan1: "Chinese",
    lan2: "English",
    lan3: "Spain",
    wz1: "Operation management center",
  },
  LoginEnterAccount: {
    wz1: "please enter the account",
    wz2: "Account login",
  },
  AccountLogin: {
    wz1: "password cannot be empty",
    wz2: "please enter the right verification code",
    wz3: "please enter the password",
    wz4: "verification code",
    wz5: "Login",
    wz6: "Account Login",
  },
  addAccountModalIntel: {
    wz1: "The account must be email or phone number",
    wz2: "The account and username cannot be empty",
    wz3: "The user addition success,please config the authority",
    wz4: "name",
    wz5: "please enter the username",
    wz6: "account",
    wz7: "please enter the account",
    wz8: "please enter the account(email/phone)",
    wz9: "Submit",
  },
  ChangePassword: {
    wz1: "the old password cannot be empty",
    wz2: "please enter the new password",
    wz3: "please confirm the password",
    wz4: "The two passwords do not match,please retry",
    wz5: "Update the password success",
    wz6: "the old password",
    wz7: "please enter the old password",
    wz8: "the new password",
    wz9: "please enter the new password",
    wz10: "please confirm the password",
    wz11: "please confirm the password",
    wz12: "Submit",
  },
  scModal: {
    text1: "Confirm",
    text2: "cancel",
  },
};



// WEBPACK FOOTER //
// ./src/AntD/locale/en-US.messages.js